import { useNavigate, useParams } from "react-router-dom";
import { submitResearchPaperApi } from "src/network/api";
import { toast } from "react-toastify";
import PageLayout from "./PageLayout";
import { useForm } from "react-hook-form";

import { Button, Card, CardBody, CardHeader } from "reactstrap";
import {
  ResearchPaperData,
  ResearchPaperForm,
} from "./CommonResearchPaperForm";
import { useState } from "react";

const CreateResearchPage = () => {
  const navigate = useNavigate();
  const { researchPaperId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    paper_title: "",
    abstract: "",
    keywords: "",
    file: null as File | null,
    author_name: "",
    author_email: "",
    author_contact: "",
    country: "",
    department: "",
    affiliation: "",
  });
  const [formGroups, setFormGroups] = useState([]);

  const onSubmit = async (data: ResearchPaperData) => {
    setIsLoading(true);
    try {
      const formDataObj = new FormData();

      // const updatedData = { ...data, co_authors: formGroups };

      for (const [key, value] of Object.entries(data)) {
        if (key !== "file" && key !== "co_authors") {
          formDataObj.append(key, value as string);
        }
      }

      console.log("Form data before file append:", data);
      if (data.file) {
        formDataObj.append("file", data.file);
        console.log("File added to FormData:", data.file);
      } else {
        toast.error("Please upload a file.");
        console.log("No file uploaded.");
        return;
      }

      if (data.co_authors && data.co_authors.length > 0) {
        formDataObj.append("co_authors", JSON.stringify(data.co_authors));
      }

      const response = await submitResearchPaperApi(formDataObj);

      if (response.status === 200 && response.data.status === 200) {
        toast.success(
          response.data.message || "Research paper submitted successfully!"
        );
        setFormGroups([]);
        window.location.reload();
        console.log("Submission Successful:", response.data);
      } else {
        toast.error(response.data.message || "Something went wrong.");
      }
    } catch (e: any) {
      console.error("Submission Failed:", e);
      toast.error(e.response?.data?.message ?? e.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PageLayout>
      <div className="mt-5 mb-5 container">
        <Card className="border-0 shadow-lg rounded-4">
          <CardHeader
            className="bg-primary text-white text-center w-100 py-3"
            style={{ margin: "0", borderRadius: "8px 8px 0 0" }}
          >
            <h3 className="mb-0 text-white">
              {researchPaperId ? "Update Research" : "Create Research"}
            </h3>
          </CardHeader>

          <CardBody className="py-4 px-4">
            <ResearchPaperForm
              onSubmit={onSubmit}
              submitButton={
                <Button
                  color="primary"
                  type="submit"
                  className="btn-block fw-bold py-2 rounded-3"
                  disabled={isLoading}
                >
                  {researchPaperId
                    ? "Update / Save Changes"
                    : "Add Research Paper"}
                </Button>
              }
            />
          </CardBody>
        </Card>
      </div>
    </PageLayout>
  );
};

export default CreateResearchPage;
